import { render, staticRenderFns } from "./Stadiums.vue?vue&type=template&id=398ffc0c&"
import script from "./Stadiums.vue?vue&type=script&lang=js&"
export * from "./Stadiums.vue?vue&type=script&lang=js&"
import style0 from "./Stadiums.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports